import {Box, FrameworkImage, Typography} from '@ttx/design-system';
import React, {FC} from 'react';
import {QuantitySelector} from './quantity-selector';

interface IItemProps {
  imageSrc?: string;
  isMobile?: boolean;
  label: string;
  artist: string;
  tokenId?: string;
  onIncrement: () => void;
  onDecrement: () => void;
  quantity: number;
  hideQtyButton: boolean;
}

export const Item: FC<IItemProps> = ({
  imageSrc,
  isMobile,
  label,
  artist,
  tokenId,
  onIncrement,
  onDecrement,
  quantity,
  hideQtyButton,
}) => {
  if (isMobile) {
    return (
      <Box
        paddingLeft="eight"
        paddingRight="eight"
        paddingTop="four"
        paddingBottom="four"
      >
        <Box flexDirection="row" alignItems="center">
          <Box marginTop="five" alignItems="center">
            <Box width={80} height={80}>
              <FrameworkImage
                style={{borderRadius: '8px'}}
                src={imageSrc || ''}
                alt={imageSrc || ''}
                width={80}
                height={80}
              />
            </Box>
          </Box>
          <Box
            width="calc(100% - 120px)"
            marginLeft="four"
            marginTop={isMobile ? 'three' : 'zero'}
            alignItems="flex-start"
          >
            <Typography fontSize="h3" textAlign="left" color="textDefault">
              {label}
            </Typography>
            <Typography fontSize="s" color="textLow">
              {artist}
            </Typography>
          </Box>
          <Box alignItems="center">
            <Box height={20}>
              <Typography textStyle="s" color="textDefault">
                X {quantity}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box>
          <QuantitySelector
            isMobile
            onIncrement={onIncrement}
            onDecrement={onDecrement}
            quantity={quantity}
            hideQtyButton={hideQtyButton}
          />
        </Box>
      </Box>
    );
  }
  return (
    <Box
      flexDirection="row"
      paddingLeft="eight"
      paddingRight="eight"
      paddingTop="four"
      paddingBottom="four"
    >
      <Box flex="2">
        <Box flexDirection="row">
          <Box width={80} height={80} marginTop="one">
            <FrameworkImage
              style={{borderRadius: '8px'}}
              src={imageSrc || ''}
              alt={imageSrc || ''}
              width={isMobile ? 366 : 80}
              height={isMobile ? 366 : 80}
            />
          </Box>

          <Box marginLeft="four" width="calc(100% - 80px)">
            <Typography fontSize="h3" textAlign="left" color="textDefault">
              {label}
            </Typography>
            <Typography fontSize="s" color="textLow">
              {artist}
            </Typography>
            {tokenId && (
              <Typography fontSize="s" color="textLow">
                Token ID: {tokenId}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
      <Box flex="1">
        <QuantitySelector
          onIncrement={onIncrement}
          onDecrement={onDecrement}
          quantity={quantity}
          hideQtyButton={hideQtyButton}
        />
      </Box>
    </Box>
  );
};
